import React, { Component } from 'react';
import {fm} from '../../services/money';

import './moneyvalue.css'

class MoneyValue extends Component {
  render() {
    let colorClass = (this.props.value < 0 ) ? 'neg-value' : 'pos-value'
    return (
      <span className={colorClass}>{fm(this.props.value, this.props.currency)}</span>
    );
  }
}

export default MoneyValue;


// WEBPACK FOOTER //
// ./src/components/MoneyValue/index.js